module.exports = __webpack_public_path__ + "static/img/banner.08dfde8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/banner.png
// module id = 1066
// module chunks = 105